import { RESET_CANDIDATE_JOURNEY, VIEW_CANDIDATE_DETAILS, VIEW_CANDIDATE_FEEDBACK, VIEW_CANDIDATE_JOURNEY } from "../actions/candidateAction";

const initialState = {
  candidatInfo: {},
  candidateJourney: {},
  candidateJourneyFeedback: [],
};

const candidateReducer = (state = initialState, action) => {
  switch (action.type) {
    case VIEW_CANDIDATE_DETAILS: {
      return {
        ...state,
        candidatInfo: action.payload,
      };
    }
    case VIEW_CANDIDATE_FEEDBACK: {
      return {
        ...state,
        candidateJourneyFeedback: action.payload,
      };
    }
    case VIEW_CANDIDATE_JOURNEY: {
      return {
        ...state,
        candidateJourney: action.payload,
      };
    }
    case RESET_CANDIDATE_JOURNEY: {
      console.log("reducer called");
      return {
        ...state,
        candidateJourney: {},
        candidateJourneyFeedback: [],
      };
    }
    default:
      return state;
  }
};

export default candidateReducer;
